var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4165 10.625C27.2314 10.073 27.0161 9.53698 26.7707 9.01687M24.6717 5.78642C24.2618 5.31022 23.8244 4.8646 23.3594 4.44954M18.3748 1.58333C18.9499 1.77029 19.5125 1.99377 20.0592 2.25242M14.4998 12.5625C14.1166 12.5625 13.742 12.6761 13.4234 12.889C13.1048 13.1019 12.8565 13.4045 12.7098 13.7586C12.5632 14.1126 12.5248 14.5022 12.5996 14.878C12.6743 15.2538 12.8589 15.5991 13.1298 15.87C13.4008 16.141 13.746 16.3255 14.1218 16.4003C14.4977 16.475 14.8873 16.4367 15.2413 16.29C15.5953 16.1434 15.8979 15.895 16.1108 15.5764C16.3237 15.2578 16.4373 14.8832 16.4373 14.5M14.4998 12.5625C15.0137 12.5625 15.5065 12.7666 15.8699 13.13C16.2332 13.4933 16.4373 13.9861 16.4373 14.5M14.4998 12.5625L14.4998 9.33333M16.4373 14.5L22.2498 14.5",
    stroke: "#27312C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 1.58366C7.36596 1.58366 1.58317 7.36645 1.58317 14.5003C1.58317 21.6342 7.36596 27.417 14.4998 27.417C21.6337 27.417 27.4165 21.6342 27.4165 14.5003",
    stroke: "#27312C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryFile);
export default __webpack_public_path__ + "static/media/historyFile.ae25266cd81fb7aba3bd92517a855291.svg";
export { ForwardRef as ReactComponent };